import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from '../ui/FadeIn';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Cómo accedo al Pack después de comprar?',
    a: 'Te llega un enlace de descarga inmediata a tu correo.'
  }, {
    q: '¿Es un producto físico o digital?',
    a: 'Es 100% digital, para usar en cualquier dispositivo.'
  }, {
    q: '¿Necesito imprimir el material?',
    a: 'No es necesario. Podés consultarlo en tu celular, tablet o computadora.'
  }, {
    q: '¿El pago es por única vez?',
    a: 'Sí, es un pago único, sin suscripciones.'
  }, {
    q: '¿Es segura la compra?',
    a: 'Absolutamente, la transacción es 100% segura.'
  }, {
    q: '¿Sirve si soy profesor o entrenador?',
    a: 'Sí, es ideal para cualquiera que quiera trabajar con criterio profesional real.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-10 bg-background border-y border-card-border relative overflow-hidden" data-id="element-64">
      <div className="container mx-auto px-4 max-w-3xl relative z-10" data-id="element-65">
        <FadeIn className="text-center mb-10" data-id="element-66">
          <h2 className="text-4xl md:text-5xl font-black mb-6 text-gray-900" data-id="element-67">
            Preguntas Frecuentes
          </h2>
          <p className="text-xl text-gray-500" data-id="element-68">
            Despejá todas tus dudas antes de empezar.
          </p>
        </FadeIn>

        <div className="space-y-4" data-id="element-69">
          {faqs.map((faq, index) => <FadeIn key={index} delay={0.1 * index} direction="up" data-id="element-70">
              <div className="bg-card border border-card-border rounded-2xl overflow-hidden transition-colors hover:border-primary/30" data-id="element-71">
                <button onClick={() => toggleFAQ(index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-72">
                  <span className="text-lg font-bold text-gray-900 pr-8" data-id="element-73">
                    {faq.q}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3
              }} className="shrink-0" data-id="element-74">
                    <ChevronDownIcon className="w-6 h-6 text-primary" data-id="element-75" />
                  </motion.div>
                </button>
                <AnimatePresence data-id="element-76">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-77">
                      <div className="px-6 pb-6 text-gray-500 leading-relaxed border-t border-card-border/50 pt-4" data-id="element-78">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}